import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/index.tsx';
import CredentialTypesTabs from './components/CredentialTypesTabs';
import CredentialTypeSelected from './components/CredentialTypeSelected';

export default function GroupingListLayout() {
  return (
    <div>
      <Header>
        <nav className="bg-white border border-secondary border-top-0 border-left-0 border-right-0 py-3">
          <div className="container">
            <div
              className="row"
              style={{
                marginBottom: '50px',
              }}
            >
              <div className="col-10 align-self-end">
                <h1 className="h4 m-0">Prospect Form Groupings</h1>
              </div>
              <div className="col-2">
                <Link to="/general-settings">
                  <button type="button" className="btn btn-primary">General Settings</button>
                </Link>
              </div>
            </div>
            <CredentialTypesTabs />
          </div>
        </nav>
      </Header>
      <div>
        <CredentialTypeSelected />
      </div>
    </div>
  );
}
